export function isFeatureRunningClientSide(name) {
    if (process.env.BUILD_TARGET !== "client")
        return false;
    return Boolean(window?.__GLOBAL_CONTEXT__?.features[name]);
}
